export const ROLES = {
  pp: {
    key: "pp",
    label: "Paraprofessional",
    short: "PP",
    email: "pp@psrnotes.com",
    tagline: "Write & dictate notes",
    can_write: true,
    can_oversee: false,
    color: "#4A6B53",
  },
  ap: {
    key: "ap",
    label: "Associate Professional",
    short: "AP",
    email: "ap@psrnotes.com",
    tagline: "Write & dictate notes",
    can_write: true,
    can_oversee: false,
    color: "#5E8268",
  },
  qp: {
    key: "qp",
    label: "Qualified Professional",
    short: "QP",
    email: "qp@psrnotes.com",
    tagline: "Write notes + review team",
    can_write: true,
    can_oversee: true,
    color: "#3D5A45",
  },
  compliance: {
    key: "compliance",
    label: "Compliance",
    short: "CO",
    email: "compliance@psrnotes.com",
    tagline: "Audit all notes (read-only)",
    can_write: false,
    can_oversee: true,
    color: "#C26D5C",
  },
  admin: {
    key: "admin",
    label: "Administrator",
    short: "AD",
    email: "admin@psrnotes.com",
    tagline: "Full access",
    can_write: true,
    can_oversee: true,
    color: "#121814",
  },
};


// Fields required for a billable PSR note per NC DHHS / Alliance standards.
export const REQUIRED_FIELDS = [
  { key: "date_of_service", label: "Date of Service" },
  { key: "type_of_contact", label: "Type of Contact" },
  { key: "place_of_service", label: "Place of Service" },
  { key: "duration_minutes", label: "Duration" },
  { key: "member_name", label: "Member Name" },
  { key: "member_id", label: "Member ID / Record #" },
  { key: "goals_addressed", label: "Targeted PCP Goal / Objective" },
  { key: "interventions", label: "Staff Interventions Provided" },
  { key: "member_response", label: "Member Response" },
  { key: "progress", label: "Progress" },
  { key: "plan", label: "Plan for Next Week" },
];

export function complianceCheck(structured = {}) {
  const missing = REQUIRED_FIELDS.filter(
    (f) => !String(structured[f.key] || "").trim()
  );
  return {
    missing,
    complete: missing.length === 0,
    filled: REQUIRED_FIELDS.length - missing.length,
    total: REQUIRED_FIELDS.length,
  };
}

// PCP review-date status for renewal reminders.
export function pcpReviewStatus(consumer = {}) {
  const d = consumer.review_date || consumer.pcp?.review_date;
  if (!d) return null;
  const date = new Date(`${d}T00:00:00`);
  if (isNaN(date)) return null;
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  const days = Math.round((date - start) / 86400000);
  if (days < 0) return { level: "overdue", days, date: d, label: "Overdue" };
  if (days <= 30) return { level: "soon", days, date: d, label: `Due in ${days}d` };
  return { level: "ok", days, date: d, label: `Review ${d}` };
}
